const _A = "Arn";
const _ACF = "AssociateChannelFlow";
const _ACFR = "AssociateChannelFlowRequest";
const _AIA = "AppInstanceArn";
const _AIUA = "AppInstanceUserArn";
const _AIUMS = "AppInstanceUserMembershipSummary";
const _AN = "AllowNotifications";
const _B = "Body";
const _BCCM = "BatchCreateChannelMembership";
const _BCCME = "BatchCreateChannelMembershipError";
const _BCCMEa = "BatchCreateChannelMembershipErrors";
const _BCCMR = "BatchCreateChannelMembershipRequest";
const _BCCMRa = "BatchCreateChannelMembershipResponse";
const _BCM = "BatchChannelMemberships";
const _BRE = "BadRequestException";
const _C = "Content";
const _CA = "ChannelArn";
const _CAWFS = "ChannelAssociatedWithFlowSummary";
const _CAWFSL = "ChannelAssociatedWithFlowSummaryList";
const _CB = "ChimeBearer";
const _CBS = "ChannelBanSummary";
const _CBSL = "ChannelBanSummaryList";
const _CBh = "ChannelBan";
const _CBha = "ChannelBans";
const _CBr = "CreatedBy";
const _CC = "CreateChannel";
const _CCB = "CreateChannelBan";
const _CCBR = "CreateChannelBanRequest";
const _CCBRr = "CreateChannelBanResponse";
const _CCF = "CreateChannelFlow";
const _CCFR = "CreateChannelFlowRequest";
const _CCFRr = "CreateChannelFlowResponse";
const _CCM = "CreateChannelMembership";
const _CCMR = "CreateChannelMembershipRequest";
const _CCMRr = "CreateChannelMembershipResponse";
const _CCMRre = "CreateChannelModeratorRequest";
const _CCMRrea = "CreateChannelModeratorResponse";
const _CCMr = "CreateChannelModerator";
const _CCR = "CreateChannelRequest";
const _CCRr = "CreateChannelResponse";
const _CE = "ConflictException";
const _CF = "ChannelFlow";
const _CFA = "ChannelFlowArn";
const _CFC = "ChannelFlowCallback";
const _CFCR = "ChannelFlowCallbackRequest";
const _CFCRh = "ChannelFlowCallbackResponse";
const _CFS = "ChannelFlowSummary";
const _CFSL = "ChannelFlowSummaryList";
const _CFh = "ChannelFlows";
const _CI = "ChannelId";
const _CIa = "CallbackId";
const _CM = "ChannelMessage";
const _CMA = "ChannelModeratorArn";
const _CMBAIUS = "ChannelModeratedByAppInstanceUserSummary";
const _CMBAIUSL = "ChannelModeratedByAppInstanceUserSummaryList";
const _CMC = "ChannelMessageCallback";
const _CMFAIUS = "ChannelMembershipForAppInstanceUserSummary";
const _CMFAIUSL = "ChannelMembershipForAppInstanceUserSummaryList";
const _CMP = "ChannelMembershipPreferences";
const _CMS = "ChannelMembershipSummary";
const _CMSL = "ChannelMembershipSummaryList";
const _CMSLh = "ChannelMessageSummaryList";
const _CMSLha = "ChannelModeratorSummaryList";
const _CMSS = "ChannelMessageStatusStructure";
const _CMSh = "ChannelMessageSummary";
const _CMSha = "ChannelModeratorSummary";
const _CMh = "ChannelMembership";
const _CMha = "ChannelModerator";
const _CMhan = "ChannelMemberships";
const _CMhann = "ChannelMessages";
const _CMhanne = "ChannelModerators";
const _CRT = "ClientRequestToken";
const _CS = "ChannelSummary";
const _CSL = "ChannelSummaryList";
const _CT = "ContentType";
const _CTr = "CreatedTimestamp";
const _Ch = "Channel";
const _Cha = "Channels";
const _Co = "Code";
const _Con = "Configuration";
const _D = "Detail";
const _DC = "DeleteChannel";
const _DCB = "DeleteChannelBan";
const _DCBR = "DeleteChannelBanRequest";
const _DCBRe = "DescribeChannelBanRequest";
const _DCBRes = "DescribeChannelBanResponse";
const _DCBe = "DescribeChannelBan";
const _DCF = "DeleteChannelFlow";
const _DCFR = "DeleteChannelFlowRequest";
const _DCFRe = "DescribeChannelFlowRequest";
const _DCFRes = "DescribeChannelFlowResponse";
const _DCFRi = "DisassociateChannelFlowRequest";
const _DCFe = "DescribeChannelFlow";
const _DCFi = "DisassociateChannelFlow";
const _DCM = "DeleteChannelMembership";
const _DCMBAIU = "DescribeChannelModeratedByAppInstanceUser";
const _DCMBAIUR = "DescribeChannelModeratedByAppInstanceUserRequest";
const _DCMBAIURe = "DescribeChannelModeratedByAppInstanceUserResponse";
const _DCMFAIU = "DescribeChannelMembershipForAppInstanceUser";
const _DCMFAIUR = "DescribeChannelMembershipForAppInstanceUserRequest";
const _DCMFAIURe = "DescribeChannelMembershipForAppInstanceUserResponse";
const _DCMR = "DeleteChannelMembershipRequest";
const _DCMRe = "DeleteChannelMessageRequest";
const _DCMRel = "DeleteChannelModeratorRequest";
const _DCMRes = "DescribeChannelMembershipRequest";
const _DCMResc = "DescribeChannelMembershipResponse";
const _DCMRescr = "DescribeChannelModeratorRequest";
const _DCMRescri = "DescribeChannelModeratorResponse";
const _DCMe = "DeleteChannelMessage";
const _DCMel = "DeleteChannelModerator";
const _DCMes = "DescribeChannelMembership";
const _DCMesc = "DescribeChannelModerator";
const _DCR = "DeleteChannelRequest";
const _DCRe = "DescribeChannelRequest";
const _DCRes = "DescribeChannelResponse";
const _DCe = "DescribeChannel";
const _DMSC = "DeleteMessagingStreamingConfigurations";
const _DMSCR = "DeleteMessagingStreamingConfigurationsRequest";
const _DR = "DeleteResource";
const _DT = "DataType";
const _E = "Errors";
const _EC = "ErrorCode";
const _ECC = "ElasticChannelConfiguration";
const _ECx = "ExpirationCriterion";
const _ED = "ExpirationDays";
const _EM = "ErrorMessage";
const _EO = "ExecutionOrder";
const _ES = "ExpirationSettings";
const _En = "Endpoint";
const _F = "Fields";
const _FA = "FallbackAction";
const _FE = "ForbiddenException";
const _FR = "FilterRule";
const _GCM = "GetChannelMessage";
const _GCMP = "GetChannelMembershipPreferences";
const _GCMPR = "GetChannelMembershipPreferencesRequest";
const _GCMPRe = "GetChannelMembershipPreferencesResponse";
const _GCMR = "GetChannelMessageRequest";
const _GCMRe = "GetChannelMessageResponse";
const _GCMS = "GetChannelMessageStatus";
const _GCMSR = "GetChannelMessageStatusRequest";
const _GCMSRe = "GetChannelMessageStatusResponse";
const _GMSC = "GetMessagingStreamingConfigurations";
const _GMSCR = "GetMessagingStreamingConfigurationsRequest";
const _GMSCRe = "GetMessagingStreamingConfigurationsResponse";
const _GMSE = "GetMessagingSessionEndpoint";
const _GMSER = "GetMessagingSessionEndpointRequest";
const _GMSERe = "GetMessagingSessionEndpointResponse";
const _I = "Identity";
const _IB = "InvitedBy";
const _IT = "InvocationType";
const _K = "Key";
const _L = "Lambda";
const _LC = "LambdaConfiguration";
const _LCAWCF = "ListChannelsAssociatedWithChannelFlow";
const _LCAWCFR = "ListChannelsAssociatedWithChannelFlowRequest";
const _LCAWCFRi = "ListChannelsAssociatedWithChannelFlowResponse";
const _LCB = "ListChannelBans";
const _LCBR = "ListChannelBansRequest";
const _LCBRi = "ListChannelBansResponse";
const _LCF = "ListChannelFlows";
const _LCFR = "ListChannelFlowsRequest";
const _LCFRi = "ListChannelFlowsResponse";
const _LCM = "ListChannelMemberships";
const _LCMBAIU = "ListChannelsModeratedByAppInstanceUser";
const _LCMBAIUR = "ListChannelsModeratedByAppInstanceUserRequest";
const _LCMBAIURi = "ListChannelsModeratedByAppInstanceUserResponse";
const _LCMFAIU = "ListChannelMembershipsForAppInstanceUser";
const _LCMFAIUR = "ListChannelMembershipsForAppInstanceUserRequest";
const _LCMFAIURi = "ListChannelMembershipsForAppInstanceUserResponse";
const _LCMR = "ListChannelMembershipsRequest";
const _LCMRi = "ListChannelMembershipsResponse";
const _LCMRis = "ListChannelMessagesRequest";
const _LCMRist = "ListChannelMessagesResponse";
const _LCMRisth = "ListChannelModeratorsRequest";
const _LCMRistha = "ListChannelModeratorsResponse";
const _LCMi = "ListChannelMessages";
const _LCMis = "ListChannelModerators";
const _LCR = "ListChannelsRequest";
const _LCRi = "ListChannelsResponse";
const _LCi = "ListChannels";
const _LET = "LastEditedTimestamp";
const _LMT = "LastMessageTimestamp";
const _LSC = "ListSubChannels";
const _LSCR = "ListSubChannelsRequest";
const _LSCRi = "ListSubChannelsResponse";
const _LTFR = "ListTagsForResource";
const _LTFRR = "ListTagsForResourceRequest";
const _LTFRRi = "ListTagsForResourceResponse";
const _LUT = "LastUpdatedTimestamp";
const _M = "Metadata";
const _MA = "MemberArn";
const _MAM = "MessageAttributeMap";
const _MAN = "MessageAttributeName";
const _MASV = "MessageAttributeStringValue";
const _MASVe = "MessageAttributeStringValues";
const _MAV = "MessageAttributeValue";
const _MAe = "MemberArns";
const _MAes = "MessageAttributes";
const _MAo = "ModeratorArns";
const _MC = "MembershipCount";
const _MI = "MessageId";
const _MMP = "MinimumMembershipPercentage";
const _MR = "MaxResults";
const _MSC = "MaximumSubChannels";
const _MSE = "MessagingSessionEndpoint";
const _Me = "Message";
const _Mem = "Members";
const _Memb = "Member";
const _Mo = "Mode";
const _Mod = "Moderator";
const _N = "Name";
const _NA = "NotAfter";
const _NB = "NotBefore";
const _NEC = "NonEmptyContent";
const _NERN = "NonEmptyResourceName";
const _NFE = "NotFoundException";
const _NT = "NextToken";
const _NTe = "NetworkType";
const _O = "Operator";
const _P = "Privacy";
const _PC = "ProcessorConfiguration";
const _PCES = "PutChannelExpirationSettings";
const _PCESR = "PutChannelExpirationSettingsRequest";
const _PCESRu = "PutChannelExpirationSettingsResponse";
const _PCMP = "PutChannelMembershipPreferences";
const _PCMPR = "PutChannelMembershipPreferencesRequest";
const _PCMPRu = "PutChannelMembershipPreferencesResponse";
const _PL = "ProcessorList";
const _PMSC = "PutMessagingStreamingConfigurations";
const _PMSCR = "PutMessagingStreamingConfigurationsRequest";
const _PMSCRu = "PutMessagingStreamingConfigurationsResponse";
const _PN = "PushNotifications";
const _PNB = "PushNotificationBody";
const _PNC = "PushNotificationConfiguration";
const _PNP = "PushNotificationPreferences";
const _PNT = "PushNotificationTitle";
const _PNu = "PushNotification";
const _Pe = "Persistence";
const _Pr = "Processors";
const _Pre = "Preferences";
const _Pro = "Processor";
const _R = "Redacted";
const _RA = "ResourceArn";
const _RARN = "ResourceARN";
const _RCM = "RedactChannelMessage";
const _RCMR = "RedactChannelMessageRequest";
const _RCMRe = "RedactChannelMessageResponse";
const _RLEE = "ResourceLimitExceededException";
const _RMT = "ReadMarkerTimestamp";
const _RN = "ResourceName";
const _S = "Sender";
const _SC = "StreamingConfigurations";
const _SCI = "SubChannelId";
const _SCL = "StreamingConfigurationList";
const _SCM = "SendChannelMessage";
const _SCMR = "SendChannelMessageRequest";
const _SCMRe = "SendChannelMessageResponse";
const _SCR = "SearchChannelsRequest";
const _SCRe = "SearchChannelsResponse";
const _SCS = "SubChannelSummary";
const _SCSL = "SubChannelSummaryList";
const _SCe = "SearchChannels";
const _SCt = "StreamingConfiguration";
const _SCu = "SubChannels";
const _SF = "SearchField";
const _SFE = "ServiceFailureException";
const _SFe = "SearchFields";
const _SO = "SortOrder";
const _SUE = "ServiceUnavailableException";
const _SV = "StringValues";
const _St = "Status";
const _T = "Type";
const _TCE = "ThrottledClientException";
const _TK = "TagKey";
const _TKL = "TagKeyList";
const _TKa = "TagKeys";
const _TL = "TagList";
const _TLa = "TargetList";
const _TMPSC = "TargetMembershipsPerSubChannel";
const _TR = "TagResource";
const _TRR = "TagResourceRequest";
const _TV = "TagValue";
const _Ta = "Target";
const _Tag = "Tags";
const _Tag_ = "Tag";
const _Ti = "Title";
const _U = "Url";
const _UC = "UpdateChannel";
const _UCE = "UnauthorizedClientException";
const _UCF = "UpdateChannelFlow";
const _UCFR = "UpdateChannelFlowRequest";
const _UCFRp = "UpdateChannelFlowResponse";
const _UCM = "UpdateChannelMessage";
const _UCMR = "UpdateChannelMessageRequest";
const _UCMRp = "UpdateChannelMessageResponse";
const _UCR = "UpdateChannelRequest";
const _UCRM = "UpdateChannelReadMarker";
const _UCRMR = "UpdateChannelReadMarkerRequest";
const _UCRMRp = "UpdateChannelReadMarkerResponse";
const _UCRp = "UpdateChannelResponse";
const _UR = "UntagResource";
const _URR = "UntagResourceRequest";
const _V = "Value";
const _Va = "Values";
const _a = "arn";
const _aia = "app-instance-arn";
const _aiua = "app-instance-user-arn";
const _c = "client";
const _cfa = "channel-flow-arn";
const _e = "error";
const _h = "http";
const _hE = "httpError";
const _hH = "httpHeader";
const _hQ = "httpQuery";
const _mr = "max-results";
const _na = "not-after";
const _nb = "not-before";
const _nt = "network-type";
const _nt_ = "next-token";
const _p = "privacy";
const _s = "server";
const _sci = "sub-channel-id";
const _sm = "smithy.ts.sdk.synthetic.com.amazonaws.chimesdkmessaging";
const _so = "sort-order";
const _t = "type";
const _xacb = "x-amz-chime-bearer";
const n0 = "com.amazonaws.chimesdkmessaging";
import { TypeRegistry } from "@smithy/core/schema";
import { ChimeSDKMessagingServiceException as __ChimeSDKMessagingServiceException } from "../models/ChimeSDKMessagingServiceException";
import { BadRequestException as __BadRequestException, ConflictException as __ConflictException, ForbiddenException as __ForbiddenException, NotFoundException as __NotFoundException, ResourceLimitExceededException as __ResourceLimitExceededException, ServiceFailureException as __ServiceFailureException, ServiceUnavailableException as __ServiceUnavailableException, ThrottledClientException as __ThrottledClientException, UnauthorizedClientException as __UnauthorizedClientException, } from "../models/index";
export var ChannelId = [0, n0, _CI, 8, 0];
export var ClientRequestToken = [0, n0, _CRT, 8, 0];
export var Content = [0, n0, _C, 8, 0];
export var ContentType = [0, n0, _CT, 8, 0];
export var FilterRule = [0, n0, _FR, 8, 0];
export var MessageAttributeName = [0, n0, _MAN, 8, 0];
export var MessageAttributeStringValue = [0, n0, _MASV, 8, 0];
export var Metadata = [0, n0, _M, 8, 0];
export var NextToken = [0, n0, _NT, 8, 0];
export var NonEmptyContent = [0, n0, _NEC, 8, 0];
export var NonEmptyResourceName = [0, n0, _NERN, 8, 0];
export var PushNotificationBody = [0, n0, _PNB, 8, 0];
export var PushNotificationTitle = [0, n0, _PNT, 8, 0];
export var ResourceName = [0, n0, _RN, 8, 0];
export var TagKey = [0, n0, _TK, 8, 0];
export var TagValue = [0, n0, _TV, 8, 0];
export var AppInstanceUserMembershipSummary = [3, n0, _AIUMS, 0, [_T, _RMT, _SCI], [0, 4, 0]];
export var AssociateChannelFlowRequest = [
    3,
    n0,
    _ACFR,
    0,
    [_CA, _CFA, _CB],
    [
        [0, 1],
        0,
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var BadRequestException = [
    -3,
    n0,
    _BRE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_Co, _Me],
    [0, 0],
];
TypeRegistry.for(n0).registerError(BadRequestException, __BadRequestException);
export var BatchChannelMemberships = [
    3,
    n0,
    _BCM,
    0,
    [_IB, _T, _Mem, _CA, _SCI],
    [[() => Identity, 0], 0, [() => Members, 0], 0, 0],
];
export var BatchCreateChannelMembershipError = [3, n0, _BCCME, 0, [_MA, _EC, _EM], [0, 0, 0]];
export var BatchCreateChannelMembershipRequest = [
    3,
    n0,
    _BCCMR,
    0,
    [_CA, _T, _MAe, _CB, _SCI],
    [
        [0, 1],
        0,
        64 | 0,
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        0,
    ],
];
export var BatchCreateChannelMembershipResponse = [
    3,
    n0,
    _BCCMRa,
    0,
    [_BCM, _E],
    [[() => BatchChannelMemberships, 0], () => BatchCreateChannelMembershipErrors],
];
export var Channel = [
    3,
    n0,
    _Ch,
    0,
    [_N, _CA, _Mo, _P, _M, _CBr, _CTr, _LMT, _LUT, _CFA, _ECC, _ES],
    [
        [() => NonEmptyResourceName, 0],
        0,
        0,
        0,
        [() => Metadata, 0],
        [() => Identity, 0],
        4,
        4,
        4,
        0,
        () => ElasticChannelConfiguration,
        () => ExpirationSettings,
    ],
];
export var ChannelAssociatedWithFlowSummary = [
    3,
    n0,
    _CAWFS,
    0,
    [_N, _CA, _Mo, _P, _M],
    [[() => NonEmptyResourceName, 0], 0, 0, 0, [() => Metadata, 0]],
];
export var ChannelBan = [
    3,
    n0,
    _CBh,
    0,
    [_Memb, _CA, _CTr, _CBr],
    [[() => Identity, 0], 0, 4, [() => Identity, 0]],
];
export var ChannelBanSummary = [3, n0, _CBS, 0, [_Memb], [[() => Identity, 0]]];
export var ChannelFlow = [
    3,
    n0,
    _CF,
    0,
    [_CFA, _Pr, _N, _CTr, _LUT],
    [0, [() => ProcessorList, 0], [() => NonEmptyResourceName, 0], 4, 4],
];
export var ChannelFlowCallbackRequest = [
    3,
    n0,
    _CFCR,
    0,
    [_CIa, _CA, _DR, _CM],
    [[0, 4], [0, 1], 2, [() => ChannelMessageCallback, 0]],
];
export var ChannelFlowCallbackResponse = [3, n0, _CFCRh, 0, [_CA, _CIa], [0, 0]];
export var ChannelFlowSummary = [
    3,
    n0,
    _CFS,
    0,
    [_CFA, _N, _Pr],
    [0, [() => NonEmptyResourceName, 0], [() => ProcessorList, 0]],
];
export var ChannelMembership = [
    3,
    n0,
    _CMh,
    0,
    [_IB, _T, _Memb, _CA, _CTr, _LUT, _SCI],
    [[() => Identity, 0], 0, [() => Identity, 0], 0, 4, 4, 0],
];
export var ChannelMembershipForAppInstanceUserSummary = [
    3,
    n0,
    _CMFAIUS,
    0,
    [_CS, _AIUMS],
    [[() => ChannelSummary, 0], () => AppInstanceUserMembershipSummary],
];
export var ChannelMembershipPreferences = [
    3,
    n0,
    _CMP,
    0,
    [_PN],
    [[() => PushNotificationPreferences, 0]],
];
export var ChannelMembershipSummary = [3, n0, _CMS, 0, [_Memb], [[() => Identity, 0]]];
export var ChannelMessage = [
    3,
    n0,
    _CM,
    0,
    [_CA, _MI, _C, _M, _T, _CTr, _LET, _LUT, _S, _R, _Pe, _St, _MAes, _SCI, _CT, _Ta],
    [
        0,
        0,
        [() => Content, 0],
        [() => Metadata, 0],
        0,
        4,
        4,
        4,
        [() => Identity, 0],
        2,
        0,
        () => ChannelMessageStatusStructure,
        [() => MessageAttributeMap, 0],
        0,
        [() => ContentType, 0],
        () => TargetList,
    ],
];
export var ChannelMessageCallback = [
    3,
    n0,
    _CMC,
    0,
    [_MI, _C, _M, _PNu, _MAes, _SCI, _CT],
    [
        0,
        [() => NonEmptyContent, 0],
        [() => Metadata, 0],
        [() => PushNotificationConfiguration, 0],
        [() => MessageAttributeMap, 0],
        0,
        [() => ContentType, 0],
    ],
];
export var ChannelMessageStatusStructure = [3, n0, _CMSS, 0, [_V, _D], [0, 0]];
export var ChannelMessageSummary = [
    3,
    n0,
    _CMSh,
    0,
    [_MI, _C, _M, _T, _CTr, _LUT, _LET, _S, _R, _St, _MAes, _CT, _Ta],
    [
        0,
        [() => Content, 0],
        [() => Metadata, 0],
        0,
        4,
        4,
        4,
        [() => Identity, 0],
        2,
        () => ChannelMessageStatusStructure,
        [() => MessageAttributeMap, 0],
        [() => ContentType, 0],
        () => TargetList,
    ],
];
export var ChannelModeratedByAppInstanceUserSummary = [
    3,
    n0,
    _CMBAIUS,
    0,
    [_CS],
    [[() => ChannelSummary, 0]],
];
export var ChannelModerator = [
    3,
    n0,
    _CMha,
    0,
    [_Mod, _CA, _CTr, _CBr],
    [[() => Identity, 0], 0, 4, [() => Identity, 0]],
];
export var ChannelModeratorSummary = [3, n0, _CMSha, 0, [_Mod], [[() => Identity, 0]]];
export var ChannelSummary = [
    3,
    n0,
    _CS,
    0,
    [_N, _CA, _Mo, _P, _M, _LMT],
    [[() => NonEmptyResourceName, 0], 0, 0, 0, [() => Metadata, 0], 4],
];
export var ConflictException = [
    -3,
    n0,
    _CE,
    {
        [_e]: _c,
        [_hE]: 409,
    },
    [_Co, _Me],
    [0, 0],
];
TypeRegistry.for(n0).registerError(ConflictException, __ConflictException);
export var CreateChannelBanRequest = [
    3,
    n0,
    _CCBR,
    0,
    [_CA, _MA, _CB],
    [
        [0, 1],
        0,
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var CreateChannelBanResponse = [3, n0, _CCBRr, 0, [_CA, _Memb], [0, [() => Identity, 0]]];
export var CreateChannelFlowRequest = [
    3,
    n0,
    _CCFR,
    0,
    [_AIA, _Pr, _N, _Tag, _CRT],
    [0, [() => ProcessorList, 0], [() => NonEmptyResourceName, 0], [() => TagList, 0], [() => ClientRequestToken, 4]],
];
export var CreateChannelFlowResponse = [3, n0, _CCFRr, 0, [_CFA], [0]];
export var CreateChannelMembershipRequest = [
    3,
    n0,
    _CCMR,
    0,
    [_CA, _MA, _T, _CB, _SCI],
    [
        [0, 1],
        0,
        0,
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        0,
    ],
];
export var CreateChannelMembershipResponse = [
    3,
    n0,
    _CCMRr,
    0,
    [_CA, _Memb, _SCI],
    [0, [() => Identity, 0], 0],
];
export var CreateChannelModeratorRequest = [
    3,
    n0,
    _CCMRre,
    0,
    [_CA, _CMA, _CB],
    [
        [0, 1],
        0,
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var CreateChannelModeratorResponse = [
    3,
    n0,
    _CCMRrea,
    0,
    [_CA, _CMha],
    [0, [() => Identity, 0]],
];
export var CreateChannelRequest = [
    3,
    n0,
    _CCR,
    0,
    [_AIA, _N, _Mo, _P, _M, _CRT, _Tag, _CB, _CI, _MAe, _MAo, _ECC, _ES],
    [
        0,
        [() => NonEmptyResourceName, 0],
        0,
        0,
        [() => Metadata, 0],
        [() => ClientRequestToken, 4],
        [() => TagList, 0],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        [() => ChannelId, 0],
        64 | 0,
        64 | 0,
        () => ElasticChannelConfiguration,
        () => ExpirationSettings,
    ],
];
export var CreateChannelResponse = [3, n0, _CCRr, 0, [_CA], [0]];
export var DeleteChannelBanRequest = [
    3,
    n0,
    _DCBR,
    0,
    [_CA, _MA, _CB],
    [
        [0, 1],
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var DeleteChannelFlowRequest = [3, n0, _DCFR, 0, [_CFA], [[0, 1]]];
export var DeleteChannelMembershipRequest = [
    3,
    n0,
    _DCMR,
    0,
    [_CA, _MA, _CB, _SCI],
    [
        [0, 1],
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        [
            0,
            {
                [_hQ]: _sci,
            },
        ],
    ],
];
export var DeleteChannelMessageRequest = [
    3,
    n0,
    _DCMRe,
    0,
    [_CA, _MI, _CB, _SCI],
    [
        [0, 1],
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        [
            0,
            {
                [_hQ]: _sci,
            },
        ],
    ],
];
export var DeleteChannelModeratorRequest = [
    3,
    n0,
    _DCMRel,
    0,
    [_CA, _CMA, _CB],
    [
        [0, 1],
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var DeleteChannelRequest = [
    3,
    n0,
    _DCR,
    0,
    [_CA, _CB],
    [
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var DeleteMessagingStreamingConfigurationsRequest = [3, n0, _DMSCR, 0, [_AIA], [[0, 1]]];
export var DescribeChannelBanRequest = [
    3,
    n0,
    _DCBRe,
    0,
    [_CA, _MA, _CB],
    [
        [0, 1],
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var DescribeChannelBanResponse = [3, n0, _DCBRes, 0, [_CBh], [[() => ChannelBan, 0]]];
export var DescribeChannelFlowRequest = [3, n0, _DCFRe, 0, [_CFA], [[0, 1]]];
export var DescribeChannelFlowResponse = [3, n0, _DCFRes, 0, [_CF], [[() => ChannelFlow, 0]]];
export var DescribeChannelMembershipForAppInstanceUserRequest = [
    3,
    n0,
    _DCMFAIUR,
    0,
    [_CA, _AIUA, _CB],
    [
        [0, 1],
        [
            0,
            {
                [_hQ]: _aiua,
            },
        ],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var DescribeChannelMembershipForAppInstanceUserResponse = [
    3,
    n0,
    _DCMFAIURe,
    0,
    [_CMh],
    [[() => ChannelMembershipForAppInstanceUserSummary, 0]],
];
export var DescribeChannelMembershipRequest = [
    3,
    n0,
    _DCMRes,
    0,
    [_CA, _MA, _CB, _SCI],
    [
        [0, 1],
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        [
            0,
            {
                [_hQ]: _sci,
            },
        ],
    ],
];
export var DescribeChannelMembershipResponse = [
    3,
    n0,
    _DCMResc,
    0,
    [_CMh],
    [[() => ChannelMembership, 0]],
];
export var DescribeChannelModeratedByAppInstanceUserRequest = [
    3,
    n0,
    _DCMBAIUR,
    0,
    [_CA, _AIUA, _CB],
    [
        [0, 1],
        [
            0,
            {
                [_hQ]: _aiua,
            },
        ],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var DescribeChannelModeratedByAppInstanceUserResponse = [
    3,
    n0,
    _DCMBAIURe,
    0,
    [_Ch],
    [[() => ChannelModeratedByAppInstanceUserSummary, 0]],
];
export var DescribeChannelModeratorRequest = [
    3,
    n0,
    _DCMRescr,
    0,
    [_CA, _CMA, _CB],
    [
        [0, 1],
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var DescribeChannelModeratorResponse = [
    3,
    n0,
    _DCMRescri,
    0,
    [_CMha],
    [[() => ChannelModerator, 0]],
];
export var DescribeChannelRequest = [
    3,
    n0,
    _DCRe,
    0,
    [_CA, _CB],
    [
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var DescribeChannelResponse = [3, n0, _DCRes, 0, [_Ch], [[() => Channel, 0]]];
export var DisassociateChannelFlowRequest = [
    3,
    n0,
    _DCFRi,
    0,
    [_CA, _CFA, _CB],
    [
        [0, 1],
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var ElasticChannelConfiguration = [3, n0, _ECC, 0, [_MSC, _TMPSC, _MMP], [1, 1, 1]];
export var ExpirationSettings = [3, n0, _ES, 0, [_ED, _ECx], [1, 0]];
export var ForbiddenException = [
    -3,
    n0,
    _FE,
    {
        [_e]: _c,
        [_hE]: 403,
    },
    [_Co, _Me],
    [0, 0],
];
TypeRegistry.for(n0).registerError(ForbiddenException, __ForbiddenException);
export var GetChannelMembershipPreferencesRequest = [
    3,
    n0,
    _GCMPR,
    0,
    [_CA, _MA, _CB],
    [
        [0, 1],
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var GetChannelMembershipPreferencesResponse = [
    3,
    n0,
    _GCMPRe,
    0,
    [_CA, _Memb, _Pre],
    [0, [() => Identity, 0], [() => ChannelMembershipPreferences, 0]],
];
export var GetChannelMessageRequest = [
    3,
    n0,
    _GCMR,
    0,
    [_CA, _MI, _CB, _SCI],
    [
        [0, 1],
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        [
            0,
            {
                [_hQ]: _sci,
            },
        ],
    ],
];
export var GetChannelMessageResponse = [3, n0, _GCMRe, 0, [_CM], [[() => ChannelMessage, 0]]];
export var GetChannelMessageStatusRequest = [
    3,
    n0,
    _GCMSR,
    0,
    [_CA, _MI, _CB, _SCI],
    [
        [0, 1],
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        [
            0,
            {
                [_hQ]: _sci,
            },
        ],
    ],
];
export var GetChannelMessageStatusResponse = [
    3,
    n0,
    _GCMSRe,
    0,
    [_St],
    [() => ChannelMessageStatusStructure],
];
export var GetMessagingSessionEndpointRequest = [
    3,
    n0,
    _GMSER,
    0,
    [_NTe],
    [
        [
            0,
            {
                [_hQ]: _nt,
            },
        ],
    ],
];
export var GetMessagingSessionEndpointResponse = [
    3,
    n0,
    _GMSERe,
    0,
    [_En],
    [() => MessagingSessionEndpoint],
];
export var GetMessagingStreamingConfigurationsRequest = [3, n0, _GMSCR, 0, [_AIA], [[0, 1]]];
export var GetMessagingStreamingConfigurationsResponse = [
    3,
    n0,
    _GMSCRe,
    0,
    [_SC],
    [() => StreamingConfigurationList],
];
export var Identity = [3, n0, _I, 0, [_A, _N], [0, [() => ResourceName, 0]]];
export var LambdaConfiguration = [3, n0, _LC, 0, [_RA, _IT], [0, 0]];
export var ListChannelBansRequest = [
    3,
    n0,
    _LCBR,
    0,
    [_CA, _MR, _NT, _CB],
    [
        [0, 1],
        [
            1,
            {
                [_hQ]: _mr,
            },
        ],
        [
            () => NextToken,
            {
                [_hQ]: _nt_,
            },
        ],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var ListChannelBansResponse = [
    3,
    n0,
    _LCBRi,
    0,
    [_CA, _NT, _CBha],
    [0, [() => NextToken, 0], [() => ChannelBanSummaryList, 0]],
];
export var ListChannelFlowsRequest = [
    3,
    n0,
    _LCFR,
    0,
    [_AIA, _MR, _NT],
    [
        [
            0,
            {
                [_hQ]: _aia,
            },
        ],
        [
            1,
            {
                [_hQ]: _mr,
            },
        ],
        [
            () => NextToken,
            {
                [_hQ]: _nt_,
            },
        ],
    ],
];
export var ListChannelFlowsResponse = [
    3,
    n0,
    _LCFRi,
    0,
    [_CFh, _NT],
    [
        [() => ChannelFlowSummaryList, 0],
        [() => NextToken, 0],
    ],
];
export var ListChannelMembershipsForAppInstanceUserRequest = [
    3,
    n0,
    _LCMFAIUR,
    0,
    [_AIUA, _MR, _NT, _CB],
    [
        [
            0,
            {
                [_hQ]: _aiua,
            },
        ],
        [
            1,
            {
                [_hQ]: _mr,
            },
        ],
        [
            () => NextToken,
            {
                [_hQ]: _nt_,
            },
        ],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var ListChannelMembershipsForAppInstanceUserResponse = [
    3,
    n0,
    _LCMFAIURi,
    0,
    [_CMhan, _NT],
    [
        [() => ChannelMembershipForAppInstanceUserSummaryList, 0],
        [() => NextToken, 0],
    ],
];
export var ListChannelMembershipsRequest = [
    3,
    n0,
    _LCMR,
    0,
    [_CA, _T, _MR, _NT, _CB, _SCI],
    [
        [0, 1],
        [
            0,
            {
                [_hQ]: _t,
            },
        ],
        [
            1,
            {
                [_hQ]: _mr,
            },
        ],
        [
            () => NextToken,
            {
                [_hQ]: _nt_,
            },
        ],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        [
            0,
            {
                [_hQ]: _sci,
            },
        ],
    ],
];
export var ListChannelMembershipsResponse = [
    3,
    n0,
    _LCMRi,
    0,
    [_CA, _CMhan, _NT],
    [0, [() => ChannelMembershipSummaryList, 0], [() => NextToken, 0]],
];
export var ListChannelMessagesRequest = [
    3,
    n0,
    _LCMRis,
    0,
    [_CA, _SO, _NB, _NA, _MR, _NT, _CB, _SCI],
    [
        [0, 1],
        [
            0,
            {
                [_hQ]: _so,
            },
        ],
        [
            4,
            {
                [_hQ]: _nb,
            },
        ],
        [
            4,
            {
                [_hQ]: _na,
            },
        ],
        [
            1,
            {
                [_hQ]: _mr,
            },
        ],
        [
            () => NextToken,
            {
                [_hQ]: _nt_,
            },
        ],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        [
            0,
            {
                [_hQ]: _sci,
            },
        ],
    ],
];
export var ListChannelMessagesResponse = [
    3,
    n0,
    _LCMRist,
    0,
    [_CA, _NT, _CMhann, _SCI],
    [0, [() => NextToken, 0], [() => ChannelMessageSummaryList, 0], 0],
];
export var ListChannelModeratorsRequest = [
    3,
    n0,
    _LCMRisth,
    0,
    [_CA, _MR, _NT, _CB],
    [
        [0, 1],
        [
            1,
            {
                [_hQ]: _mr,
            },
        ],
        [
            () => NextToken,
            {
                [_hQ]: _nt_,
            },
        ],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var ListChannelModeratorsResponse = [
    3,
    n0,
    _LCMRistha,
    0,
    [_CA, _NT, _CMhanne],
    [0, [() => NextToken, 0], [() => ChannelModeratorSummaryList, 0]],
];
export var ListChannelsAssociatedWithChannelFlowRequest = [
    3,
    n0,
    _LCAWCFR,
    0,
    [_CFA, _MR, _NT],
    [
        [
            0,
            {
                [_hQ]: _cfa,
            },
        ],
        [
            1,
            {
                [_hQ]: _mr,
            },
        ],
        [
            () => NextToken,
            {
                [_hQ]: _nt_,
            },
        ],
    ],
];
export var ListChannelsAssociatedWithChannelFlowResponse = [
    3,
    n0,
    _LCAWCFRi,
    0,
    [_Cha, _NT],
    [
        [() => ChannelAssociatedWithFlowSummaryList, 0],
        [() => NextToken, 0],
    ],
];
export var ListChannelsModeratedByAppInstanceUserRequest = [
    3,
    n0,
    _LCMBAIUR,
    0,
    [_AIUA, _MR, _NT, _CB],
    [
        [
            0,
            {
                [_hQ]: _aiua,
            },
        ],
        [
            1,
            {
                [_hQ]: _mr,
            },
        ],
        [
            () => NextToken,
            {
                [_hQ]: _nt_,
            },
        ],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var ListChannelsModeratedByAppInstanceUserResponse = [
    3,
    n0,
    _LCMBAIURi,
    0,
    [_Cha, _NT],
    [
        [() => ChannelModeratedByAppInstanceUserSummaryList, 0],
        [() => NextToken, 0],
    ],
];
export var ListChannelsRequest = [
    3,
    n0,
    _LCR,
    0,
    [_AIA, _P, _MR, _NT, _CB],
    [
        [
            0,
            {
                [_hQ]: _aia,
            },
        ],
        [
            0,
            {
                [_hQ]: _p,
            },
        ],
        [
            1,
            {
                [_hQ]: _mr,
            },
        ],
        [
            () => NextToken,
            {
                [_hQ]: _nt_,
            },
        ],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var ListChannelsResponse = [
    3,
    n0,
    _LCRi,
    0,
    [_Cha, _NT],
    [
        [() => ChannelSummaryList, 0],
        [() => NextToken, 0],
    ],
];
export var ListSubChannelsRequest = [
    3,
    n0,
    _LSCR,
    0,
    [_CA, _CB, _MR, _NT],
    [
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        [
            1,
            {
                [_hQ]: _mr,
            },
        ],
        [
            () => NextToken,
            {
                [_hQ]: _nt_,
            },
        ],
    ],
];
export var ListSubChannelsResponse = [
    3,
    n0,
    _LSCRi,
    0,
    [_CA, _SCu, _NT],
    [0, () => SubChannelSummaryList, [() => NextToken, 0]],
];
export var ListTagsForResourceRequest = [
    3,
    n0,
    _LTFRR,
    0,
    [_RARN],
    [
        [
            0,
            {
                [_hQ]: _a,
            },
        ],
    ],
];
export var ListTagsForResourceResponse = [3, n0, _LTFRRi, 0, [_Tag], [[() => TagList, 0]]];
export var MessageAttributeValue = [
    3,
    n0,
    _MAV,
    0,
    [_SV],
    [[() => MessageAttributeStringValues, 0]],
];
export var MessagingSessionEndpoint = [3, n0, _MSE, 0, [_U], [0]];
export var NotFoundException = [
    -3,
    n0,
    _NFE,
    {
        [_e]: _c,
        [_hE]: 404,
    },
    [_Co, _Me],
    [0, 0],
];
TypeRegistry.for(n0).registerError(NotFoundException, __NotFoundException);
export var Processor = [
    3,
    n0,
    _Pro,
    0,
    [_N, _Con, _EO, _FA],
    [[() => NonEmptyResourceName, 0], () => ProcessorConfiguration, 1, 0],
];
export var ProcessorConfiguration = [3, n0, _PC, 0, [_L], [() => LambdaConfiguration]];
export var PushNotificationConfiguration = [
    3,
    n0,
    _PNC,
    0,
    [_Ti, _B, _T],
    [[() => PushNotificationTitle, 0], [() => PushNotificationBody, 0], 0],
];
export var PushNotificationPreferences = [
    3,
    n0,
    _PNP,
    0,
    [_AN, _FR],
    [0, [() => FilterRule, 0]],
];
export var PutChannelExpirationSettingsRequest = [
    3,
    n0,
    _PCESR,
    0,
    [_CA, _CB, _ES],
    [
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        () => ExpirationSettings,
    ],
];
export var PutChannelExpirationSettingsResponse = [
    3,
    n0,
    _PCESRu,
    0,
    [_CA, _ES],
    [0, () => ExpirationSettings],
];
export var PutChannelMembershipPreferencesRequest = [
    3,
    n0,
    _PCMPR,
    0,
    [_CA, _MA, _CB, _Pre],
    [
        [0, 1],
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        [() => ChannelMembershipPreferences, 0],
    ],
];
export var PutChannelMembershipPreferencesResponse = [
    3,
    n0,
    _PCMPRu,
    0,
    [_CA, _Memb, _Pre],
    [0, [() => Identity, 0], [() => ChannelMembershipPreferences, 0]],
];
export var PutMessagingStreamingConfigurationsRequest = [
    3,
    n0,
    _PMSCR,
    0,
    [_AIA, _SC],
    [[0, 1], () => StreamingConfigurationList],
];
export var PutMessagingStreamingConfigurationsResponse = [
    3,
    n0,
    _PMSCRu,
    0,
    [_SC],
    [() => StreamingConfigurationList],
];
export var RedactChannelMessageRequest = [
    3,
    n0,
    _RCMR,
    0,
    [_CA, _MI, _CB, _SCI],
    [
        [0, 1],
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        0,
    ],
];
export var RedactChannelMessageResponse = [3, n0, _RCMRe, 0, [_CA, _MI, _SCI], [0, 0, 0]];
export var ResourceLimitExceededException = [
    -3,
    n0,
    _RLEE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_Co, _Me],
    [0, 0],
];
TypeRegistry.for(n0).registerError(ResourceLimitExceededException, __ResourceLimitExceededException);
export var SearchChannelsRequest = [
    3,
    n0,
    _SCR,
    0,
    [_CB, _F, _MR, _NT],
    [
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        () => SearchFields,
        [
            1,
            {
                [_hQ]: _mr,
            },
        ],
        [
            () => NextToken,
            {
                [_hQ]: _nt_,
            },
        ],
    ],
];
export var SearchChannelsResponse = [
    3,
    n0,
    _SCRe,
    0,
    [_Cha, _NT],
    [
        [() => ChannelSummaryList, 0],
        [() => NextToken, 0],
    ],
];
export var SearchField = [3, n0, _SF, 0, [_K, _Va, _O], [0, 64 | 0, 0]];
export var SendChannelMessageRequest = [
    3,
    n0,
    _SCMR,
    0,
    [_CA, _C, _T, _Pe, _M, _CRT, _CB, _PNu, _MAes, _SCI, _CT, _Ta],
    [
        [0, 1],
        [() => NonEmptyContent, 0],
        0,
        0,
        [() => Metadata, 0],
        [() => ClientRequestToken, 4],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        [() => PushNotificationConfiguration, 0],
        [() => MessageAttributeMap, 0],
        0,
        [() => ContentType, 0],
        () => TargetList,
    ],
];
export var SendChannelMessageResponse = [
    3,
    n0,
    _SCMRe,
    0,
    [_CA, _MI, _St, _SCI],
    [0, 0, () => ChannelMessageStatusStructure, 0],
];
export var ServiceFailureException = [
    -3,
    n0,
    _SFE,
    {
        [_e]: _s,
        [_hE]: 500,
    },
    [_Co, _Me],
    [0, 0],
];
TypeRegistry.for(n0).registerError(ServiceFailureException, __ServiceFailureException);
export var ServiceUnavailableException = [
    -3,
    n0,
    _SUE,
    {
        [_e]: _s,
        [_hE]: 503,
    },
    [_Co, _Me],
    [0, 0],
];
TypeRegistry.for(n0).registerError(ServiceUnavailableException, __ServiceUnavailableException);
export var StreamingConfiguration = [3, n0, _SCt, 0, [_DT, _RA], [0, 0]];
export var SubChannelSummary = [3, n0, _SCS, 0, [_SCI, _MC], [0, 1]];
export var Tag = [
    3,
    n0,
    _Tag_,
    0,
    [_K, _V],
    [
        [() => TagKey, 0],
        [() => TagValue, 0],
    ],
];
export var TagResourceRequest = [3, n0, _TRR, 0, [_RARN, _Tag], [0, [() => TagList, 0]]];
export var Target = [3, n0, _Ta, 0, [_MA], [0]];
export var ThrottledClientException = [
    -3,
    n0,
    _TCE,
    {
        [_e]: _c,
        [_hE]: 429,
    },
    [_Co, _Me],
    [0, 0],
];
TypeRegistry.for(n0).registerError(ThrottledClientException, __ThrottledClientException);
export var UnauthorizedClientException = [
    -3,
    n0,
    _UCE,
    {
        [_e]: _c,
        [_hE]: 401,
    },
    [_Co, _Me],
    [0, 0],
];
TypeRegistry.for(n0).registerError(UnauthorizedClientException, __UnauthorizedClientException);
export var UntagResourceRequest = [3, n0, _URR, 0, [_RARN, _TKa], [0, [() => TagKeyList, 0]]];
export var UpdateChannelFlowRequest = [
    3,
    n0,
    _UCFR,
    0,
    [_CFA, _Pr, _N],
    [
        [0, 1],
        [() => ProcessorList, 0],
        [() => NonEmptyResourceName, 0],
    ],
];
export var UpdateChannelFlowResponse = [3, n0, _UCFRp, 0, [_CFA], [0]];
export var UpdateChannelMessageRequest = [
    3,
    n0,
    _UCMR,
    0,
    [_CA, _MI, _C, _M, _CB, _SCI, _CT],
    [
        [0, 1],
        [0, 1],
        [() => NonEmptyContent, 0],
        [() => Metadata, 0],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
        0,
        [() => ContentType, 0],
    ],
];
export var UpdateChannelMessageResponse = [
    3,
    n0,
    _UCMRp,
    0,
    [_CA, _MI, _St, _SCI],
    [0, 0, () => ChannelMessageStatusStructure, 0],
];
export var UpdateChannelReadMarkerRequest = [
    3,
    n0,
    _UCRMR,
    0,
    [_CA, _CB],
    [
        [0, 1],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var UpdateChannelReadMarkerResponse = [3, n0, _UCRMRp, 0, [_CA], [0]];
export var UpdateChannelRequest = [
    3,
    n0,
    _UCR,
    0,
    [_CA, _N, _Mo, _M, _CB],
    [
        [0, 1],
        [() => NonEmptyResourceName, 0],
        0,
        [() => Metadata, 0],
        [
            0,
            {
                [_hH]: _xacb,
            },
        ],
    ],
];
export var UpdateChannelResponse = [3, n0, _UCRp, 0, [_CA], [0]];
export var __Unit = "unit";
export var ChimeSDKMessagingServiceException = [
    -3,
    _sm,
    "ChimeSDKMessagingServiceException",
    0,
    [],
    [],
];
TypeRegistry.for(_sm).registerError(ChimeSDKMessagingServiceException, __ChimeSDKMessagingServiceException);
export var BatchCreateChannelMembershipErrors = [
    1,
    n0,
    _BCCMEa,
    0,
    () => BatchCreateChannelMembershipError,
];
export var ChannelAssociatedWithFlowSummaryList = [
    1,
    n0,
    _CAWFSL,
    0,
    [() => ChannelAssociatedWithFlowSummary, 0],
];
export var ChannelBanSummaryList = [1, n0, _CBSL, 0, [() => ChannelBanSummary, 0]];
export var ChannelFlowSummaryList = [1, n0, _CFSL, 0, [() => ChannelFlowSummary, 0]];
export var ChannelMemberArns = 64 | 0;
export var ChannelMembershipForAppInstanceUserSummaryList = [
    1,
    n0,
    _CMFAIUSL,
    0,
    [() => ChannelMembershipForAppInstanceUserSummary, 0],
];
export var ChannelMembershipSummaryList = [1, n0, _CMSL, 0, [() => ChannelMembershipSummary, 0]];
export var ChannelMessageSummaryList = [1, n0, _CMSLh, 0, [() => ChannelMessageSummary, 0]];
export var ChannelModeratedByAppInstanceUserSummaryList = [
    1,
    n0,
    _CMBAIUSL,
    0,
    [() => ChannelModeratedByAppInstanceUserSummary, 0],
];
export var ChannelModeratorArns = 64 | 0;
export var ChannelModeratorSummaryList = [1, n0, _CMSLha, 0, [() => ChannelModeratorSummary, 0]];
export var ChannelSummaryList = [1, n0, _CSL, 0, [() => ChannelSummary, 0]];
export var MemberArns = 64 | 0;
export var Members = [1, n0, _Mem, 0, [() => Identity, 0]];
export var MessageAttributeStringValues = [1, n0, _MASVe, 0, [() => MessageAttributeStringValue, 0]];
export var ProcessorList = [1, n0, _PL, 0, [() => Processor, 0]];
export var SearchFields = [1, n0, _SFe, 0, () => SearchField];
export var SearchFieldValues = 64 | 0;
export var StreamingConfigurationList = [1, n0, _SCL, 0, () => StreamingConfiguration];
export var SubChannelSummaryList = [1, n0, _SCSL, 0, () => SubChannelSummary];
export var TagKeyList = [1, n0, _TKL, 0, [() => TagKey, 0]];
export var TagList = [1, n0, _TL, 0, [() => Tag, 0]];
export var TargetList = [1, n0, _TLa, 0, () => Target];
export var MessageAttributeMap = [
    2,
    n0,
    _MAM,
    0,
    [() => MessageAttributeName, 0],
    [() => MessageAttributeValue, 0],
];
export var AssociateChannelFlow = [
    9,
    n0,
    _ACF,
    {
        [_h]: ["PUT", "/channels/{ChannelArn}/channel-flow", 200],
    },
    () => AssociateChannelFlowRequest,
    () => __Unit,
];
export var BatchCreateChannelMembership = [
    9,
    n0,
    _BCCM,
    {
        [_h]: ["POST", "/channels/{ChannelArn}/memberships?operation=batch-create", 200],
    },
    () => BatchCreateChannelMembershipRequest,
    () => BatchCreateChannelMembershipResponse,
];
export var ChannelFlowCallback = [
    9,
    n0,
    _CFC,
    {
        [_h]: ["POST", "/channels/{ChannelArn}?operation=channel-flow-callback", 200],
    },
    () => ChannelFlowCallbackRequest,
    () => ChannelFlowCallbackResponse,
];
export var CreateChannel = [
    9,
    n0,
    _CC,
    {
        [_h]: ["POST", "/channels", 201],
    },
    () => CreateChannelRequest,
    () => CreateChannelResponse,
];
export var CreateChannelBan = [
    9,
    n0,
    _CCB,
    {
        [_h]: ["POST", "/channels/{ChannelArn}/bans", 201],
    },
    () => CreateChannelBanRequest,
    () => CreateChannelBanResponse,
];
export var CreateChannelFlow = [
    9,
    n0,
    _CCF,
    {
        [_h]: ["POST", "/channel-flows", 201],
    },
    () => CreateChannelFlowRequest,
    () => CreateChannelFlowResponse,
];
export var CreateChannelMembership = [
    9,
    n0,
    _CCM,
    {
        [_h]: ["POST", "/channels/{ChannelArn}/memberships", 201],
    },
    () => CreateChannelMembershipRequest,
    () => CreateChannelMembershipResponse,
];
export var CreateChannelModerator = [
    9,
    n0,
    _CCMr,
    {
        [_h]: ["POST", "/channels/{ChannelArn}/moderators", 201],
    },
    () => CreateChannelModeratorRequest,
    () => CreateChannelModeratorResponse,
];
export var DeleteChannel = [
    9,
    n0,
    _DC,
    {
        [_h]: ["DELETE", "/channels/{ChannelArn}", 204],
    },
    () => DeleteChannelRequest,
    () => __Unit,
];
export var DeleteChannelBan = [
    9,
    n0,
    _DCB,
    {
        [_h]: ["DELETE", "/channels/{ChannelArn}/bans/{MemberArn}", 204],
    },
    () => DeleteChannelBanRequest,
    () => __Unit,
];
export var DeleteChannelFlow = [
    9,
    n0,
    _DCF,
    {
        [_h]: ["DELETE", "/channel-flows/{ChannelFlowArn}", 204],
    },
    () => DeleteChannelFlowRequest,
    () => __Unit,
];
export var DeleteChannelMembership = [
    9,
    n0,
    _DCM,
    {
        [_h]: ["DELETE", "/channels/{ChannelArn}/memberships/{MemberArn}", 204],
    },
    () => DeleteChannelMembershipRequest,
    () => __Unit,
];
export var DeleteChannelMessage = [
    9,
    n0,
    _DCMe,
    {
        [_h]: ["DELETE", "/channels/{ChannelArn}/messages/{MessageId}", 204],
    },
    () => DeleteChannelMessageRequest,
    () => __Unit,
];
export var DeleteChannelModerator = [
    9,
    n0,
    _DCMel,
    {
        [_h]: ["DELETE", "/channels/{ChannelArn}/moderators/{ChannelModeratorArn}", 204],
    },
    () => DeleteChannelModeratorRequest,
    () => __Unit,
];
export var DeleteMessagingStreamingConfigurations = [
    9,
    n0,
    _DMSC,
    {
        [_h]: ["DELETE", "/app-instances/{AppInstanceArn}/streaming-configurations", 204],
    },
    () => DeleteMessagingStreamingConfigurationsRequest,
    () => __Unit,
];
export var DescribeChannel = [
    9,
    n0,
    _DCe,
    {
        [_h]: ["GET", "/channels/{ChannelArn}", 200],
    },
    () => DescribeChannelRequest,
    () => DescribeChannelResponse,
];
export var DescribeChannelBan = [
    9,
    n0,
    _DCBe,
    {
        [_h]: ["GET", "/channels/{ChannelArn}/bans/{MemberArn}", 200],
    },
    () => DescribeChannelBanRequest,
    () => DescribeChannelBanResponse,
];
export var DescribeChannelFlow = [
    9,
    n0,
    _DCFe,
    {
        [_h]: ["GET", "/channel-flows/{ChannelFlowArn}", 200],
    },
    () => DescribeChannelFlowRequest,
    () => DescribeChannelFlowResponse,
];
export var DescribeChannelMembership = [
    9,
    n0,
    _DCMes,
    {
        [_h]: ["GET", "/channels/{ChannelArn}/memberships/{MemberArn}", 200],
    },
    () => DescribeChannelMembershipRequest,
    () => DescribeChannelMembershipResponse,
];
export var DescribeChannelMembershipForAppInstanceUser = [
    9,
    n0,
    _DCMFAIU,
    {
        [_h]: ["GET", "/channels/{ChannelArn}?scope=app-instance-user-membership", 200],
    },
    () => DescribeChannelMembershipForAppInstanceUserRequest,
    () => DescribeChannelMembershipForAppInstanceUserResponse,
];
export var DescribeChannelModeratedByAppInstanceUser = [
    9,
    n0,
    _DCMBAIU,
    {
        [_h]: ["GET", "/channels/{ChannelArn}?scope=app-instance-user-moderated-channel", 200],
    },
    () => DescribeChannelModeratedByAppInstanceUserRequest,
    () => DescribeChannelModeratedByAppInstanceUserResponse,
];
export var DescribeChannelModerator = [
    9,
    n0,
    _DCMesc,
    {
        [_h]: ["GET", "/channels/{ChannelArn}/moderators/{ChannelModeratorArn}", 200],
    },
    () => DescribeChannelModeratorRequest,
    () => DescribeChannelModeratorResponse,
];
export var DisassociateChannelFlow = [
    9,
    n0,
    _DCFi,
    {
        [_h]: ["DELETE", "/channels/{ChannelArn}/channel-flow/{ChannelFlowArn}", 204],
    },
    () => DisassociateChannelFlowRequest,
    () => __Unit,
];
export var GetChannelMembershipPreferences = [
    9,
    n0,
    _GCMP,
    {
        [_h]: ["GET", "/channels/{ChannelArn}/memberships/{MemberArn}/preferences", 200],
    },
    () => GetChannelMembershipPreferencesRequest,
    () => GetChannelMembershipPreferencesResponse,
];
export var GetChannelMessage = [
    9,
    n0,
    _GCM,
    {
        [_h]: ["GET", "/channels/{ChannelArn}/messages/{MessageId}", 200],
    },
    () => GetChannelMessageRequest,
    () => GetChannelMessageResponse,
];
export var GetChannelMessageStatus = [
    9,
    n0,
    _GCMS,
    {
        [_h]: ["GET", "/channels/{ChannelArn}/messages/{MessageId}?scope=message-status", 200],
    },
    () => GetChannelMessageStatusRequest,
    () => GetChannelMessageStatusResponse,
];
export var GetMessagingSessionEndpoint = [
    9,
    n0,
    _GMSE,
    {
        [_h]: ["GET", "/endpoints/messaging-session", 200],
    },
    () => GetMessagingSessionEndpointRequest,
    () => GetMessagingSessionEndpointResponse,
];
export var GetMessagingStreamingConfigurations = [
    9,
    n0,
    _GMSC,
    {
        [_h]: ["GET", "/app-instances/{AppInstanceArn}/streaming-configurations", 200],
    },
    () => GetMessagingStreamingConfigurationsRequest,
    () => GetMessagingStreamingConfigurationsResponse,
];
export var ListChannelBans = [
    9,
    n0,
    _LCB,
    {
        [_h]: ["GET", "/channels/{ChannelArn}/bans", 200],
    },
    () => ListChannelBansRequest,
    () => ListChannelBansResponse,
];
export var ListChannelFlows = [
    9,
    n0,
    _LCF,
    {
        [_h]: ["GET", "/channel-flows", 200],
    },
    () => ListChannelFlowsRequest,
    () => ListChannelFlowsResponse,
];
export var ListChannelMemberships = [
    9,
    n0,
    _LCM,
    {
        [_h]: ["GET", "/channels/{ChannelArn}/memberships", 200],
    },
    () => ListChannelMembershipsRequest,
    () => ListChannelMembershipsResponse,
];
export var ListChannelMembershipsForAppInstanceUser = [
    9,
    n0,
    _LCMFAIU,
    {
        [_h]: ["GET", "/channels?scope=app-instance-user-memberships", 200],
    },
    () => ListChannelMembershipsForAppInstanceUserRequest,
    () => ListChannelMembershipsForAppInstanceUserResponse,
];
export var ListChannelMessages = [
    9,
    n0,
    _LCMi,
    {
        [_h]: ["GET", "/channels/{ChannelArn}/messages", 200],
    },
    () => ListChannelMessagesRequest,
    () => ListChannelMessagesResponse,
];
export var ListChannelModerators = [
    9,
    n0,
    _LCMis,
    {
        [_h]: ["GET", "/channels/{ChannelArn}/moderators", 200],
    },
    () => ListChannelModeratorsRequest,
    () => ListChannelModeratorsResponse,
];
export var ListChannels = [
    9,
    n0,
    _LCi,
    {
        [_h]: ["GET", "/channels", 200],
    },
    () => ListChannelsRequest,
    () => ListChannelsResponse,
];
export var ListChannelsAssociatedWithChannelFlow = [
    9,
    n0,
    _LCAWCF,
    {
        [_h]: ["GET", "/channels?scope=channel-flow-associations", 200],
    },
    () => ListChannelsAssociatedWithChannelFlowRequest,
    () => ListChannelsAssociatedWithChannelFlowResponse,
];
export var ListChannelsModeratedByAppInstanceUser = [
    9,
    n0,
    _LCMBAIU,
    {
        [_h]: ["GET", "/channels?scope=app-instance-user-moderated-channels", 200],
    },
    () => ListChannelsModeratedByAppInstanceUserRequest,
    () => ListChannelsModeratedByAppInstanceUserResponse,
];
export var ListSubChannels = [
    9,
    n0,
    _LSC,
    {
        [_h]: ["GET", "/channels/{ChannelArn}/subchannels", 200],
    },
    () => ListSubChannelsRequest,
    () => ListSubChannelsResponse,
];
export var ListTagsForResource = [
    9,
    n0,
    _LTFR,
    {
        [_h]: ["GET", "/tags", 200],
    },
    () => ListTagsForResourceRequest,
    () => ListTagsForResourceResponse,
];
export var PutChannelExpirationSettings = [
    9,
    n0,
    _PCES,
    {
        [_h]: ["PUT", "/channels/{ChannelArn}/expiration-settings", 200],
    },
    () => PutChannelExpirationSettingsRequest,
    () => PutChannelExpirationSettingsResponse,
];
export var PutChannelMembershipPreferences = [
    9,
    n0,
    _PCMP,
    {
        [_h]: ["PUT", "/channels/{ChannelArn}/memberships/{MemberArn}/preferences", 200],
    },
    () => PutChannelMembershipPreferencesRequest,
    () => PutChannelMembershipPreferencesResponse,
];
export var PutMessagingStreamingConfigurations = [
    9,
    n0,
    _PMSC,
    {
        [_h]: ["PUT", "/app-instances/{AppInstanceArn}/streaming-configurations", 200],
    },
    () => PutMessagingStreamingConfigurationsRequest,
    () => PutMessagingStreamingConfigurationsResponse,
];
export var RedactChannelMessage = [
    9,
    n0,
    _RCM,
    {
        [_h]: ["POST", "/channels/{ChannelArn}/messages/{MessageId}?operation=redact", 200],
    },
    () => RedactChannelMessageRequest,
    () => RedactChannelMessageResponse,
];
export var SearchChannels = [
    9,
    n0,
    _SCe,
    {
        [_h]: ["POST", "/channels?operation=search", 200],
    },
    () => SearchChannelsRequest,
    () => SearchChannelsResponse,
];
export var SendChannelMessage = [
    9,
    n0,
    _SCM,
    {
        [_h]: ["POST", "/channels/{ChannelArn}/messages", 201],
    },
    () => SendChannelMessageRequest,
    () => SendChannelMessageResponse,
];
export var TagResource = [
    9,
    n0,
    _TR,
    {
        [_h]: ["POST", "/tags?operation=tag-resource", 204],
    },
    () => TagResourceRequest,
    () => __Unit,
];
export var UntagResource = [
    9,
    n0,
    _UR,
    {
        [_h]: ["POST", "/tags?operation=untag-resource", 204],
    },
    () => UntagResourceRequest,
    () => __Unit,
];
export var UpdateChannel = [
    9,
    n0,
    _UC,
    {
        [_h]: ["PUT", "/channels/{ChannelArn}", 200],
    },
    () => UpdateChannelRequest,
    () => UpdateChannelResponse,
];
export var UpdateChannelFlow = [
    9,
    n0,
    _UCF,
    {
        [_h]: ["PUT", "/channel-flows/{ChannelFlowArn}", 200],
    },
    () => UpdateChannelFlowRequest,
    () => UpdateChannelFlowResponse,
];
export var UpdateChannelMessage = [
    9,
    n0,
    _UCM,
    {
        [_h]: ["PUT", "/channels/{ChannelArn}/messages/{MessageId}", 200],
    },
    () => UpdateChannelMessageRequest,
    () => UpdateChannelMessageResponse,
];
export var UpdateChannelReadMarker = [
    9,
    n0,
    _UCRM,
    {
        [_h]: ["PUT", "/channels/{ChannelArn}/readMarker", 200],
    },
    () => UpdateChannelReadMarkerRequest,
    () => UpdateChannelReadMarkerResponse,
];
